import { render, staticRenderFns } from "./mo-org-dash.vue?vue&type=template&id=040c9402&scoped=true&"
import script from "./mo-org-dash.vue?vue&type=script&lang=js&"
export * from "./mo-org-dash.vue?vue&type=script&lang=js&"
import style0 from "./mo-org-dash.vue?vue&type=style&index=0&id=040c9402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c9402",
  null
  
)

export default component.exports